const serviceProviderList = (state) => state.serviceProviderList;

export default {
  serviceProviderList,
}


// WEBPACK FOOTER //
// ./src/store/modules/serviceProvider/getters.js